import { render, staticRenderFns } from "./IndicadoresDataTable.vue?vue&type=template&id=b2f2bdfc&scoped=true"
import script from "./IndicadoresDataTable.vue?vue&type=script&lang=js"
export * from "./IndicadoresDataTable.vue?vue&type=script&lang=js"
import style0 from "./IndicadoresDataTable.vue?vue&type=style&index=0&id=b2f2bdfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f2bdfc",
  null
  
)

export default component.exports